import { SectionHead } from '../primitives';

/**
 * Mockups & Diagrams — placeholder. The "mockup/diagram" object type does not
 * exist yet, so this section surfaces nothing and import is disabled. It renders
 * a "coming soon" state until the object type ships. (Canvas-typed documents are
 * shown in the Documents section in the meantime.)
 */
export function ProjectArtifactsSection() {
  return (
    <section className="pn-section" data-testid="project-artifacts-section">
      <SectionHead title="Mockups & Diagrams" />
      <div className="pn-coming-soon" data-testid="project-artifacts-coming-soon">
        <span className="pn-coming-soon-badge">Coming soon</span>
        <p className="pn-coming-soon-text">
          Mockups &amp; diagrams will live here once the object type ships.
        </p>
      </div>
    </section>
  );
}
